import { useLocation } from 'react-router-dom';
import { APP_ROUTES } from '../Router/routes';

const useLocationName = function useLocationName() {
  const location = useLocation();

  const currentSection = Object.keys(APP_ROUTES).find(
    (x) => APP_ROUTES[x] === location?.pathname
  );

  return currentSection;
};

export default useLocationName;
